import debounce from 'lodash.debounce';
import React, { useState } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/shared/buttons/Button';
import ContainerHeader from '../../components/shared/container/ContainerHeader';
import Search from '../../components/shared/search/Search';
import { getTasksActions, setTasksSearchAction } from '../../redux/actions/tasksActions';
import CreateTaskModal from './modals/CreateTaskModal';

const TasksHeader = ({ readOnly }) => {
  const dispatch = useDispatch();
  const search = useSelector((state) => state.tasks?.search);
  const [showCreateTaskModal, setShowCreateTaskModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const debounced = debounce((args) => {
    dispatch(setTasksSearchAction(args));
  }, 500);

  const handleSearchChange = (newSearchValue) => {
    debounced(newSearchValue);
  };

  const handleTaskModalSubmit = async () => {
    setShowCreateTaskModal(false);
    setLoading(true);
    await dispatch(getTasksActions(search));
    setLoading(false);
  };

  return (
    <ContainerHeader>
      {showCreateTaskModal && (
        <CreateTaskModal
          onModalSubmit={() => handleTaskModalSubmit()}
          onModalClose={() => setShowCreateTaskModal(false)}
        />
      )}
      <Search value={search.search} onChangeAction={handleSearchChange} />
      {!readOnly && (
        <Button variant={'primary'} disabled={loading} onClick={() => setShowCreateTaskModal(true)}>
          <AiOutlinePlus />
          Додати
        </Button>
      )}
    </ContainerHeader>
  );
};

export default TasksHeader;
